export const DefaultPageSizes = [5, 10, 20, 50, 100];
